import React from 'react';
import { Outlet } from 'react-router-dom';
import NewsletterSignup from '../components/molecules/newsletter-signup/newsletter-signup-molecule';
import Footer from '../components/organisms/footer/footer';

const Layout = () => {
	return (
		<div className='min-h-screen'>
			<main
				role='main'
				className=''
				/* When banner is visible, use this classes -> className='mt-[46px] xl:mt-[60px]'*/
			>
				<Outlet />
			</main>
			<NewsletterSignup />
			<Footer />
		</div>
	);
};

export default Layout;
